import { inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  FILES_APIV3_DOMAIN,
  FILES_PANEL_DOMAIN,
} from '../../environments/environment.token';

export abstract class BaseEditLogo {
  initialLogos: string[] = [];
  filesToUpload: any[] = [];

  private readonly serverUrl = inject(FILES_APIV3_DOMAIN);
  private readonly severUrlUsers = inject(FILES_PANEL_DOMAIN);

  abstract getForm(): FormGroup;

  initLogo(path: string | null | undefined, isUsers: boolean = false): void {
    if (path) {
      if (path.startsWith('http')) {
        this.initialLogos = [path];
      } else if (isUsers) {
        this.initialLogos = [this.severUrlUsers + path];
      } else {
        this.initialLogos = [this.serverUrl + path];
      }
    } else {
      this.initialLogos = [];
    }
  }

  imgReqIsEmpty(formData: FormData) {
    const isFilesEmpty = !this.filesToUpload || this.filesToUpload.length === 0;
    const isInitialEmpty = !this.initialLogos || this.initialLogos.length === 0;

    if (isFilesEmpty && isInitialEmpty) {
      formData.append('imgIsEmpty', 'true');
    } else {
      formData.append('imgIsEmpty', 'false');
    }

    return formData;
  }

  handleImagesUpdate(
    event: { initial: string[]; newlyUploaded: any[] },
    controlName: string = 'logo_url'
  ): void {
    this.filesToUpload = event.newlyUploaded;
    this.initialLogos = event.initial;

    if (this.initialLogos.length === 0 && this.filesToUpload.length === 0) {
      this.getForm().get(controlName)?.setValue(null);
    }
  }
}
